export default "__VITE_ASSET__PZG$CECE__"